import React from "react";
import { styled } from "@glitz/react";
import { black, green, grey, fontSize, spacing } from "../theme";
import { useCart } from "../context/CartContext";

interface FreeShippingProgressProps {
  threshold?: number;
}

const FreeShippingProgress: React.FC<FreeShippingProgressProps> = ({
  threshold = 999,
}) => {
  const { getMerchandiseAfterPackage } = useCart();
  const total = getMerchandiseAfterPackage();
  const progress = Math.min((total / threshold) * 100, 100);

  return (
    <Wrapper>
      <Text>{`Fri frakt över ${threshold} kr`}</Text>
      <Bar>
        <Filler
          css={{
            width: `${progress}%`,
            backgroundColor: total >= threshold ? green : black,
          }}
        />
      </Bar>
      <Text>
        {total >= threshold ? (
          <span>
            <strong>Du har fri frakt!</strong>
          </span>
        ) : (
          <span>
            Du har <strong>{threshold - total} kr</strong> kvar till{" "}
            <strong>frifrakt</strong>
          </span>
        )}
      </Text>
    </Wrapper>
  );
};

const Wrapper = styled.div({
  width: "100%",
  maxWidth: "400px",
});

const Bar = styled.div({
  width: "100%",
  height: "8px",
  backgroundColor: grey,
  borderRadius: "4px",
  overflow: "hidden",
});

const Filler = styled.div({
  height: "100%",
  transitionProperty: "width",
  transitionDuration: "0.3s",
  transitionTimingFunction: "ease-in-out",
});

const Text = styled.div({
  fontSize: fontSize.m,
  marginTop: spacing.s,
  marginBottom: spacing.s,
});

export default FreeShippingProgress;
